import { motion } from 'framer-motion'
import { LayoutDashboard, FileCheck, FileText, BookOpen, MessageSquare } from 'lucide-react'

interface StudentBottomNavProps {
    activeTab: string
    setActiveTab: (tab: string) => void
}

export function StudentBottomNav({ activeTab, setActiveTab }: StudentBottomNavProps) {
    const navItems = [
        { id: 'dashboard', label: 'Home', icon: LayoutDashboard },
        { id: 'daily-plan', label: 'Plan', icon: FileCheck },
        { id: 'tests', label: 'Tests', icon: FileText },
        { id: 'study-material', label: 'Material', icon: BookOpen },
        { id: 'chat', label: 'Chat', icon: MessageSquare },
    ]

    return (
        <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800 pb-safe z-50">
            <div className="flex items-center justify-around px-1 py-1">
                {navItems.map((item) => {
                    const Icon = item.icon
                    const isActive = activeTab === item.id
                    return (
                        <motion.button
                            key={item.id}
                            onClick={() => setActiveTab(item.id)}
                            whileTap={{ scale: 0.92 }}
                            className={`relative flex flex-col items-center gap-0.5 py-2 px-3 rounded-lg transition-colors min-w-0 flex-1 ${isActive
                                ? 'text-primary-blue'
                                : 'text-slate-400'
                                }`}
                        >
                            {/* Active Indicator */}
                            {isActive && (
                                <motion.div
                                    layoutId="bottomNavIndicator"
                                    className="absolute -top-0.5 w-6 h-1 bg-primary-blue rounded-full"
                                    transition={{ type: 'spring', stiffness: 500, damping: 35 }}
                                />
                            )}

                            <Icon className={`h-5 w-5 ${isActive ? 'stroke-[2.5px]' : ''}`} />
                            <span className={`text-[10px] ${isActive ? 'font-semibold' : 'font-medium'} truncate`}>{item.label}</span>
                        </motion.button>
                    )
                })}
            </div>
        </div>
    )
}
